export type NodeTestProps = {
    'data-testid': string;
    id: string;
};

export type NodeTestIdProp = {
    'data-testid': string;
};

export const getNodeTestProps = (id: string): NodeTestProps => ({
    'data-testid': id,
    id,
});

export const getNodeTestIdProp = (id: string): NodeTestIdProp => ({
    'data-testid': id,
});
